// You can write more code here

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
import { ProgressBarBrain } from '@/game/GameComponents/PhaserGame/UI/ProgressBarBrain';
/* END-USER-IMPORTS */

export default class ProgressBarWithCheckbox
  extends Phaser.GameObjects.Container
{
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    this.scaleX = 2;
    this.scaleY = 2;

    // barBacking
    const barBacking = scene.add.nineslice(
      0,
      0,
      'mastery-progress-bar',
      undefined,
      80,
      6,
      2,
      2,
      2,
      2,
    );
    barBacking.scaleX = 2;
    barBacking.scaleY = 2;
    barBacking.setOrigin(0, 0.5);
    this.add(barBacking);

    // barFill
    const barFill = scene.add.nineslice(
      2,
      0,
      'mastery-progress-fill',
      undefined,
      78,
      4,
      2,
      2,
      2,
      2,
    );
    barFill.scaleX = 2;
    barFill.scaleY = 2;
    barFill.setOrigin(0, 0.5);
    this.add(barFill);

    // barMask
    const barMask = scene.add.rectangle(2, 0, 156, 16);
    barMask.setOrigin(0, 0.5);
    barMask.alpha = 0;
    barMask.isFilled = true;
    this.add(barMask);

    // checkboxContainer
    const checkboxContainer = scene.add.container(8, -16);
    this.add(checkboxContainer);

    // checkbox
    const checkbox = scene.add.image(0, 0, '8check05');
    checkbox.scaleX = 2;
    checkbox.scaleY = 2;
    checkboxContainer.add(checkbox);

    this.barBacking = barBacking;
    this.barFill = barFill;
    this.barMask = barMask;
    this.checkbox = checkbox;
    this.checkboxContainer = checkboxContainer;

    /* START-USER-CTR-CODE */
    this.brain = new ProgressBarBrain(this);
    /* END-USER-CTR-CODE */
  }

  public barBacking: Phaser.GameObjects.NineSlice;
  public barFill: Phaser.GameObjects.NineSlice;
  public barMask: Phaser.GameObjects.Rectangle;
  public checkbox: Phaser.GameObjects.Image;
  public checkboxContainer: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  // Write your code here.
  public brain: ProgressBarBrain;

  destroy() {
    this.brain.destroy();
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
